import pranjal from "./ExTeam/images/pranjal.jpg";
import shashank1 from "./ExTeam/images/shashank.jpg";
import risabh from "./ExTeam/images/rishabh.jpg";
import shashank2 from "./ExTeam/images/shashank2.jpg";
import vivek from "./ExTeam/images/vivek.jpg";
import prathmesh from "./ExTeam/images/prathmesh.jpg";
import ishita from "./ExTeam/images/ishita.jpg";
import radhika from "./ExTeam/images/radhika.jpg";
import avi from "./ExTeam/images/avi.jpg";

const gensec2020 = [
  {
    img: pranjal,
    name: "Pranjal Shukla",
    pos: "General Secretary",
    fb: "https://www.facebook.com/pranjal.shukla.1401",
    insta: "#",
    linkedin: "https://www.linkedin.com/in/pranjal-shukla-862404184/",
    contact: "#",
    mail: "#",
  },
  {
    img: shashank1,
    name: "Shashank Shrivastava",
    pos: "General Secretary",
    fb: "https://www.facebook.com/shank.2311",
    linkedin: "https://www.linkedin.com/in/shashank--shrivastava/",
    contact: "#",
    mail: "#",
  },
];

const eventHead2020 = [
  {
    name: "Rishabh Agrawal",
    img: risabh,
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/rishabh.a.568",
    linkedin: "https://www.linkedin.com/in/rishabh-agrawal-135713172/",
    contact: "#",
    mail: "#",
  },

  {
    name: "Shashank Srivastava",
    pos: "Senior Coordinator",
    img: shashank2,
    fb: "https://www.facebook.com/shashank.srivastava.719",
    linkedin: "https://www.linkedin.com/in/shashank-srivastava-911540172/",
    contact: "#",
    mail: "#",
  },
];

const sponsHead2020 = [
  
  {
    name: "Ishita Agarwal",
    pos: "Senior Coordinator",
    img: ishita,
    fb: "https://www.facebook.com/ishita.agarwal.9212301",
    linkedin: "https://www.linkedin.com/in/ishita-agarwal-b1617a173/",
    contact: "#",
    mail: "#",
  },
  {
    name: "Prathmesh Deshmukh",
    img: prathmesh,
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/prathmesh.deshmukh.5661",
    linkedin: "https://www.linkedin.com/in/prathmeshd/",
    contact: "#",
    mail: "#",
  },

];

const designHead2020 = [
  {
    img: vivek,
    name: "Vivek Shirode",
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/vivek.shirode",
    linkedin: "https://www.linkedin.com/in/vivekashirode/",
    contact: "#",
    mail: "#",
  },
  {
    name: "Radhika Agrawal",
    pos: "Web Design Coordinator",
    img: radhika,
    fb: "https://www.facebook.com/radhika.agrawal.121398",
    insta: "#",
    linkedin: "https://www.linkedin.com/in/radhikaagr18/",
    mail: "#",
    contact: "#",
  },
  {
    name: "Avi Agarwal",
    img: avi,
    pos: "Graphics Design Coordinator",
    fb: "https://www.facebook.com/avi.agarwal.7311",
    linkedin: "https://www.linkedin.com/in/avi-agarwal-7953b1174/",
    contact: "#",
    mail: "#",
  },
];

export { gensec2020,sponsHead2020, designHead2020, eventHead2020};